export default "__VITE_ASSET__CG295B6q__"